/**
 * Labstep
 *
 * @module components/ProtocolValue/Action/QRScan
 * @desc ProtocolValue QR Scan Action
 */

import { useHasAccess } from 'labstep-web/components/Entity/Can/hooks';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { PermaLinkActionQRScan } from 'labstep-web/components/PermaLink/Action/QRScan';
import { ProtocolValuePermaLinkReader } from 'labstep-web/components/ProtocolValue/PermaLinkReader';
import { EntityUpdateContainer } from 'labstep-web/containers/Entity/Update';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { IProtocolValueActionQRScanProps } from './types';

export const ProtocolValueActionQRScan: React.FC<
  IProtocolValueActionQRScanProps
> = ({ protocolValue }) => {
  const hasAccess = useHasAccess(
    protocolValue.entityName,
    protocolValue.idAttr,
    Action.edit,
    ['resource', 'resource_item'],
  );

  return (
    <EntityUpdateContainer
      entityName={protocolValue.entityName}
      id={protocolValue.guid}
    >
      {({ update }) => (
        <Modal
          header="Scan Item"
          content={({ toggleModal }) => (
            <ProtocolValuePermaLinkReader
              update={update}
              toggleReader={toggleModal}
            />
          )}
          viewComponent={({ toggleModal }) => (
            <PermaLinkActionQRScan
              actionComponentProps={{
                dataCy: 'components/ProtocolValue/Action/QRScan',
                dataTestId: 'icon qrcode',
                disabled: !hasAccess,
                text: 'Scan Item',
                onClick: toggleModal,
              }}
            />
          )}
        />
      )}
    </EntityUpdateContainer>
  );
};
